import React, { useState, useEffect } from 'react'
import './styles.scss'
import Heading from '../heading/Heading'
import LeasingRateBox from '../leasing-rate-box/LeasingRateBox';
import { useSelector, useDispatch } from 'react-redux'
import phoneIco from './../../images/phone-ico.svg'
import checkNaN from '../../services/checkNaN';
import formatPrice from '../../services/formatPrice';
import DownloadIcon from './../../images/download-icon.svg';

const LeasingRate = ( props ) => {
    let callNumber = useSelector(state => state.callNumber);
    
    let activeContract = useSelector(state => state.selectedLease); 
    let isShop = useSelector(state => state.isShop); 
    
    return (
        <>
            <div className={"leasing-rate " + (isShop ? 'shop' : '') }>
                <div className="wrap">
                    <div className="shadow-box">
                        <Heading title="Leasing installment calculation"
                                    tip={ true } 
                                    tipHeader="Leasing installment calculation"
                                    tipText={ `The Initial Term set out above shall commence on the first day of the Gregorian calendar quarter (i. e. 01 January, 01 April, 01 July, 01 October) following the date of delivery of the Leased Object(s) set out above in case, the Lessee has to pay the Leasing Fee as set out above quarterly in advance and shall commence on the first day of the next calendar month in case, the Lessee has to pay the Leasing Fee on a monthly basis (“Commencement Date”). The Lessee has to pay 1/30 (One Thirtieth) of the monthly Leasing Fee for each day of the interim period between delivery of the Leased Object(s) and Commencement Date. This interim period is subject to the conditions of this Classic Lease Contract (“Contract”), as defined in the “General Terms and Conditions of Lease” (“GTC”) and the GTC.` }
                        />
                        
                        <LeasingRateBox textRate="Quarterly 4 times a year"
                            price4={ props.rate4 }
                            price12={ props.rate12 }
                            text="The above amounts are subject to VAT. This calculation is for informational purposes only and does not constitute an offer within the meaning of the Civil Code." 
                            activeRate4={ props.activeRate4 } 
                            changePage={ () => props.changePage() } 
                            forceValidate={ props.forceValidate } />
                    </div>
                </div>
            </div>
            <div className="download-links mobile">
                <a className="link" href={`${window.location.origin}/7_UAE Insurance Conditions.pdf`} target="_blank">
                    <div className="icon">
                        <img src={DownloadIcon} alt="" />
                    </div>
                    Insurance conditions
                </a>
                <a className="link" href="" target="_blank">
                    <div className="icon">
                        <img src={DownloadIcon} alt="" />
                    </div>
                    Benefits of Grenke rental
                </a>
                <a className="link" href="https://www.grenke.ae/gtc/" target="_blank">
                    <div className="icon">
                        <img src={DownloadIcon} alt="" />
                    </div>
                    Terms and Conditions
                </a>
            </div>
        </>
    )
}

export default LeasingRate;